import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart quantity selector.
 * The minus button stays enabled at quantity 1 and removes the line
 * by dispatching quantity 0 on the next click.
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Cart selectors use the absolute variant maximum.
   * @returns {number | null}
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }

  /**
   * Keep minus available for removable cart lines, including at quantity 1.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    minusButton.disabled = this.serverDisabledMinus;

    plusButton.disabled =
      this.serverDisabledPlus ||
      (effectiveMax !== null && value >= effectiveMax);
  }

  /**
   * When the current quantity is already at its minimum,
   * send quantity 0 so Horizon removes the cart line.
   *
   * @param {Event} event
   */
  decreaseQuantity(event) {
    if (!(event.target instanceof HTMLElement)) return;

    event.preventDefault();

    const { quantityInput } = this.refs;
    const { min, value } = this.getCurrentValues();

    if (value <= min) {
      quantityInput.value = '0';
      this.onQuantityChange();
      return;
    }

    this.updateQuantity(-1);
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}